/**
 *  输入元素ID，滚动到元素顶部
 */
export function scrollElementToTop(
  target: string | HTMLElement | null | undefined,
  behavior: ScrollBehavior = 'smooth'
) {
  window.requestAnimationFrame(() => {
    const el =
      typeof target === 'string' ? document.getElementById(target) : target;
    if (!el) return;

    let parent: HTMLElement | null = el.parentElement;
    while (parent) {
      const { overflowY } = window.getComputedStyle(parent);
      const canScroll =
        (overflowY === 'auto' ||
          overflowY === 'scroll' ||
          overflowY === 'overlay') &&
        parent.scrollHeight > parent.clientHeight + 1;
      if (canScroll) {
        const parentRect = parent.getBoundingClientRect();
        const targetRect = el.getBoundingClientRect();
        const top = Math.max(
          0,
          parent.scrollTop + (targetRect.top - parentRect.top)
        );
        parent.scrollTo({ top, behavior });
        return;
      }
      parent = parent.parentElement;
    }
    el.scrollIntoView({ behavior, block: 'start' });
  });
}
